<script setup lang="ts">
import { computed } from 'vue';

import useSectionState from '@/state/useSectionState';
import useFilterState from '@/state/useFilterState';

// Components
import ControlsHeader from '@/components/ControlsHeader/ControlsHeader.vue';
import TableView from '@/components/Table/TableView.vue';
import StatusBox from '@/components/StatusBox/StatusBox.vue';

import type { Table } from '@/declarations/main';

const props = defineProps<{
  table: Table,
}>();
const emit = defineEmits(['changeInterval', 'update']);

const {
  intervals,
  dataId,
  compsetsFilter,
} = useSectionState();
const {
  selectedMetric,
} = useFilterState();

const changeInterval = (interval: string) => {
  emit('changeInterval', intervals.filter((m) => m.name === interval)[0]?.name);
};

const handleUpdate = (getTableExportData: () => void) => {
  emit('update', getTableExportData);
};

const tableUpdateKey = computed(() => `${dataId.value}_${props.table.selectedInterval}_${selectedMetric.value}_${compsetsFilter.value.join('-')}`);
</script>

<template>
  <LpCard class="bm-card wrapper-highlight flex flex-col gap-6 p-8">
    <ControlsHeader
      :id="table.id"
      :type="'table'"
      :title="table.title"
      :tp-config="table.tooltipConfig"
      :loading="table.type !== 'breakdown' && table.loading"
      :intervals="intervals"
      :selected-interval="table.selectedInterval"

      :change-interval="changeInterval"
    />

    <StatusBox
      v-if="table.error.show && !table.loading"
      :error="table.error"
    />

    <TableView
      v-else
      :id="table.id"
      :key="tableUpdateKey"
      :table-rows="table.tableRows"
      :column-description="table.columnDescription"
      :loading="table.loading"

      @update="handleUpdate"
    />
  </LpCard>
</template>
